import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { API_URL } from "../../../constants";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import { toast } from "react-hot-toast";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const Signup = ({ phoneNumber ,setStep}) => {
  const validationSchema = Yup.object().shape({
		first_name: Yup.string().required('نام  را وارد کنید'),
		last_name: Yup.string().required('نام خانوادگی را وارد کنید'),
	
            password: Yup.string()
			.required('رمز عبور را وارد کنید')
			.min(8, 'رمز عبور کوتاه است.حداقل هشت رقم وارد کنید')
			
            .test("passwordRequirements", "پسوورد باید شامل اعداد و حروف باشد", (value) =>
            [/[a-z]/, /[0-9]/].every((pattern) =>
              pattern.test(value)
            )
          ),

		
	});
  const formOptions = {
    mode: "onChange",
    resolver: yupResolver(validationSchema)
  };
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm(formOptions);
  const [info, setinfo] = useState();
  const sendregister = () => {
    // axios.defaults.withCredentials = true
    axios({
      method: "get",
      url: `${API_URL}/sanctum/csrf-cookie`
    }).then(function(res) {
      console.log(res);
      axios({
        method: "post",
        url: `${API_URL}/api/auth/register`,
        data: info,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(function(res) {
          toast.success(res.data.message);
          setStep(2)
        })
        .catch(function(response) {
          console.log("err", response);
        });
    });
  };
  const onSubmit = data => {
    setinfo({...data,phone:phoneNumber.phone})
  };
  useEffect(() => {
   if(info){
    sendregister()
   }
  }, [info])
  
  return (
    <div>
      <h2>ثبت نام</h2>
      <p className="register-sub">
        ثبت نام شما رو تبریک می گوییم جهت ورود به وبسایت جاتیک اطلاعات حساب
        کاربری خود را تکمیل کنید
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          name="first_name"
          control={control}
          errors={errors}
          placeholder=" نام "
        />
        <Input
          name="last_name"
          control={control}
          className='mt-[20px]'
          errors={errors}
          placeholder="  نام خانوادگی"
        />
        <Input
          name="password"
          control={control}
          errors={errors}
          type='password'
          className="my-[20px]"
          placeholder="رمز عبور جدید خود را وارد کنید"
        />
        <Button varient="primary" type="submit" fullwidth>
          ارسال اطلاعات
        </Button>
      </form>
    </div>
  );
};

export default Signup;
